import moment from "moment";
import React, { useEffect, useState } from "react";

export default function Sync({ cue, cloud }) {
	const [t, setT] = useState();
	const [i, setI] = useState(null);
	const [beep, setBeep] = useState(0);

	useEffect(() => {
		clearInterval(i);

		// FPS 60 = 1000 / 60 == 16.6

		setI(
			setInterval(() => {
				let now = moment();
				setT(now);
				setBeep(parseInt(now.format("SSSS")));
				console.log(Math.floor(parseInt(now.format("SSSS")) / 16 / 21));
			}, 10)
		);

		return () => {
			clearInterval(i);
		};
	}, []);
	return (
		<div className="w-screen h-screen flex flex-col items-center justify-center ">
			<span className="p-s4 text-s12xl font-bold font-mono bg-gray-800 rounded-ssm">
				{moment(t).format(cue.format || "SSSS")}
			</span>
			<div className="flex pt-s4">
				{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => {
					return (
						<span
							style={{ width: "2vw", height: "2vh" }}
							className={`ml-s4 bg-gray-100 ${
								num !== beep ? "opacity-10" : "opacity-100"
							}`}
						></span>
					);
				})}
			</div>
			{beep}
		</div>
	);
}
